import React from 'react';
import EventForm from './form';
import {getEventItem, updateEventItem} from '../../modules/Api';
import {normalizer, prepareForEdit} from './pipeline';
import {notification} from 'antd';

class EditEvent extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false
        }
        
    }
    componentDidMount() {
        this.fetchEventDetail();
    }
    fetchEventDetail() {
        const eventId = this.props.match.params.id;
        getEventItem(eventId, data => {this.setState({data: prepareForEdit(data)})});
    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const eventId = this.props.match.params.id;
        const formData = normalizer(values);
        updateEventItem(eventId, formData, () => {
            notification.open({
                message: `رویداد ویرایش شد!`,
                description: ``
            });

            this.setState({submitted: false});

        })
    }
    render() {
        return (<div><EventForm initialData={this.state.data} submit={this.submit.bind(this)}/></div>);
    }
}

export default EditEvent;


// WEBPACK FOOTER //
// ./src/containers/Events/edit.js